import { useAtom } from "jotai";
import { homePinsAtom } from "./atoms";
import { getPinIcon } from "../../../utils/maps";
import { Venue } from "../../../types/venue";
import { useMemo } from "react";

export function useHomeVenues() {
  const [{ data, error, isLoading, isFetching }] = useAtom(homePinsAtom);

  // Memoize the locations array
  const locations = useMemo(() => {
    // If there's no data or no locations, return an empty array
    if (!data?.locations) {
      return undefined;
    }
    
    // This .map() will now only run if `data.locations` changes
    return data.locations.map((e: Venue) => {
      if (e.venuePinType) return e;
      return {
        ...e,
        venuePinType: getPinIcon(e),
      };
    });
  }, [data?.locations]); // <--- Dependency array for useMemo

  return {
    locations,
    newRegion: data?.newRegion,
    error,
    isLoading,
    isFetching,
    newLocation: data?.newLocation,
    search_original_distance: data?.search_original_distance,
    search_distance_used: data?.search_distance_used,
    total_count: data?.total_count,
    filtered_venues: data?.filtered_venues,
    data,
  };
}